<app-menu-template3>
    <main class="container-fluid">
        <article class="row bg-white shadow my-3 mx-0">
            <section class="col-12 p-4">
                <div class="d-flex justify-content-between mb-3">
                    <header class="row d-flex align-items-center">
                        <img src="../../../../../assets/icons/solicitud.png"
                            class="d-inline-block p-2 rounded-circle" alt="" height="60">
                        <label class="text-dark h5 mb-0 font-weight-bold">Ajuste de anotaciones</label>
                    </header>
                </div>

                <div class="card mb-3">
                    <div class="card-body p-3">
                        <!-- <header class="text-center mb-3">
                            <label class="h5">Filtra tu consulta</label>
                        </header> -->

                        <form [formGroup]="formFiltroSolicitud" (ngSubmit)="onFiltrar()">
                            <div class="row">
                                <div class="form-group col-3">
                                    <label class="small text-secondary mb-0">Cámara de Comercio</label>
                                    <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                                        <option value="" selected="true">
                                            Seleccione
                                        </option>
                                        <option *ngFor="let option of camarasLista" value="{{option.codigo_camara}}"
                                            [selected]="false">
                                            {{option.desc_camara}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-3">
                                    <label class="small text-secondary mb-0">Número de radicado</label>
                                    <input formControlName="numero_radicado" type="text" class="form-control form-control-sm">
                                </div>
                                <div class="form-group col-3">
                                    <label class="small text-secondary mb-0">Número RNT</label>
                                    <input formControlName="codigo_rnt" type="text" class="form-control form-control-sm">
                                </div>
                            </div>
                            <div class="form-row mt-3">
                                <button type="reset" class="btn btn-outline-primary border-0" (click)="reset()">Limpiar</button>
                                <button class="btn btn-primary solicitud-btn-principal ml-3" type="submit">Filtrar</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="table-responsive">
                    <app-tablas 
                            [headers]="headers"
                            [page]="paginaActual" 
                            [sizeData]="dataTabla.paging.totalItems"
                            (paginado)="onPaginado($event)">
                        <tr *ngFor="let item of anotaciones" class="small">
                            <td>{{item.solicitudId}}</td>
                            <td>{{item.fechaCreacion | date:'d/MMM/yyyy, h:mm a'}}</td>
                            <td>{{item.numeroRadicado}}</td>
                            <td>{{item.tipoSolicitud}}</td>
                            <td>{{item.tipoAnotacion}}</td>
                            <td>{{item.descripcion}}</td>
                            <td>{{item.usuarioCreacion}}</td>
                            <td>
                                <div ngbDropdown container="body">
                                    <button type="button" class="btn btn-outline-primary btn-sm" ngbDropdownToggle>
                                        {{item.activo ? 'Activo' : 'Inactivo'}}
                                    </button>
                                    <div ngbDropdownMenu>
                                        <ng-container *ngIf="item.activo">
                                            <button ngbDropdownItem (click)="item.activo = false">Inactivo</button>
                                        </ng-container>
                                        <ng-container *ngIf="!item.activo">
                                            <button ngbDropdownItem (click)="item.activo = true">Activo</button>
                                        </ng-container>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button class="btn btn-primary btn-sm" (click)="activarInactivarAnotacion(item)">
                                    Guardar
                                </button>
                            </td>
                        </tr>
                    </app-tablas>
                </div>
            </section>
        </article>
    </main>
</app-menu-template3>